import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const SectionContainer = styled.View`
  margin: 0 24px;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  margin-bottom: ${RFValue(16)}px;
`;

export const TitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(8)}px;
`;

export const IconWrapper = styled.View`
  background-color: #009688;
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(6)}px;
  justify-content: center;
  align-items: center;
`;

export const FipeIcon = styled(MaterialCommunityIcons).attrs({
  name: 'car-info',
  size: RFValue(18),
  color: '#FFFFFF',
})``;

export const TitleColumn = styled.View``;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
`;

export const FormRow = styled.View`
  flex-direction: row;
  align-items: flex-end;
  gap: ${RFValue(10)}px;
`;

export const InputWrapper = styled.View`
  flex: 1;
`;

export const ButtonWrapper = styled.View`
  width: ${RFValue(110)}px;
`;
